"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateOneStage_FindOpAmp = calculateOneStage_FindOpAmp;
exports.calculateOneStage_FixedOpAmp = calculateOneStage_FixedOpAmp;
exports.calculateTwoStages_FindOpAmp = calculateTwoStages_FindOpAmp;
exports.calculateTwoStages_FixedOpAmp = calculateTwoStages_FixedOpAmp;
exports.findOpAmp = findOpAmp;
exports.findOpAmp1 = findOpAmp1;
exports.findOpAmp2 = findOpAmp2;
exports.oneStageRf = oneStageRf;
exports.stage1Info_DualStage = stage1Info_DualStage;
exports.stage1Info_SingleStage = stage1Info_SingleStage;
exports.stage2Info = stage2Info;
var Common = _interopRequireWildcard(require("./common"));
var Solver = _interopRequireWildcard(require("./solver"));
var _circuit = require("./circuit");
var _model = require("./model");
var _photodiodeConstants = _interopRequireDefault(require("./photodiode-constants"));
var _modelError = _interopRequireDefault(require("./models/model-error"));
var _errorCodes = _interopRequireDefault(require("./error-codes"));
var _messages = _interopRequireDefault(require("./messages"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function calculateOneStage_FindOpAmp(userInputs, opAmpDB) {
  var i,
    stage1 = null,
    stage1Array = [],
    needFaster = 0;

  //Get our Rf
  var results = oneStageRf(userInputs);

  // check for errors
  if (results instanceof _modelError.default) {
    return results;
  }

  //no errors, proceed
  var rf = results.rf;

  //Get stage info for all op amps
  for (i = 0; i < opAmpDB.length; i++) {
    stage1 = stage1Info_SingleStage(rf, userInputs, opAmpDB[i]);
    stage1Array.push(stage1);
    needFaster += stage1.needFaster;
  }

  //Pick the highest scoring op amp out of the recommended list
  results = (0, _circuit.pickOpAmp_TIA)(stage1Array, userInputs, opAmpDB, needFaster);

  // check for errors
  if (results instanceof _modelError.default) return results;
  return {
    stage1: results.stage1,
    stage2: null
  };
}
function findOpAmp(userInputs, opAmpDB) {
  let result = calculateOneStage_FindOpAmp(userInputs, opAmpDB);
  if (result instanceof _modelError.default) return result;
  return result.stage1.opAmp;
}

// This function calculates the values for a single stage circuit when the op amp is already known
function calculateOneStage_FixedOpAmp(userInputs, opAmpDB) {
  var results,
    rf,
    i,
    opAmpObject,
    stage1 = null;
  var errorObject = {
    errorCode: "",
    errorParameter: {},
    notRecommendedAvailable: false
  };

  //Get our Rf
  results = oneStageRf(userInputs);

  // check for errors
  if (results instanceof _modelError.default) return results;

  //no errors, proceed
  rf = results.rf;

  //Find op amp object
  var opAmpName = userInputs.opAmps[0];
  for (i = 0; i < opAmpDB.length; i++) {
    if (opAmpDB[i].partNumber === opAmpName) {
      opAmpObject = opAmpDB[i];
      break;
    }
  }

  //Get stage info for our op amp
  stage1 = stage1Info_SingleStage(rf, userInputs, opAmpObject);
  if (stage1.cf > 0 && stage1.cfext < 0) {
    errorObject.errorCode = _errorCodes.default.internalCfTooHigh;
    errorObject.errorParameter.partName = stage1.opAmp.partNumber;
    errorObject.errorParameter.cf = stage1.cf;
    errorObject.errorParameter.cfint = stage1.cfint;
    errorObject.errorParameter.cfext = stage1.cfext;
    errorObject.errorParameter.statusMessage = stage1.statusMessage;
    return (0, _model.setModelError)(errorObject);
  } else {
    if (stage1.status != _photodiodeConstants.default.opAmpStatus.allowed && stage1.status != _photodiodeConstants.default.opAmpStatus.recommended) {
      errorObject.errorCode = _errorCodes.default.fixedOpAmpNoGood;
      errorObject.errorParameter.partName = opAmpName;
      errorObject.errorParameter.statusMessage = stage1.statusMessage;
      return (0, _model.setModelError)(errorObject);
    }
  }
  return {
    stage1: stage1,
    stage2: null
  };
}

//This function generates the stage information for the user's inputs, given an rf and an opAmpObject
function stage1Info_SingleStage(rf, userInputs, opAmpObject) {
  var results, rIn, gbw;

  //set up circuit calculations based on whether current or voltage feedback
  if (opAmpObject.feedbackMethod === "Current" && opAmpObject.cfb) {
    //if current feedback, we can use all the same voltage feedback equations if we just make these two changes:
    rIn = opAmpObject.cfb.rIn;
    gbw = opAmpObject.cfb.zbw / rIn;
  } else {
    rIn = userInputs.shuntResistance;
    gbw = opAmpObject.gbw;
  }

  //calculate bandwidth and cf
  var Q = userInputs.peaking;
  var cDiff = opAmpObject.cDiff;
  var cCm = opAmpObject.cCm;
  var cIn = cDiff + cCm + userInputs.capacitance;
  var bw = Solver.solveBW_CfFlexible(rf, rIn, Q, cIn, gbw);
  var cf = Solver.solveCf_BWFlexible(rf, rIn, Q, cIn, gbw);
  var cfint = opAmpObject.cfint;
  var cfext = cf - cfint;

  //convert cfext to standard value if it is larger than 1 pf.  If smaller, don't convert, with the assumption that parasitic
  //capacitance screws things up anyway.
  if (cfext > _photodiodeConstants.default.Limits.CSMALL_COMP_1PF) {
    results = Common.capacitorBasedOnTolerance(cfext, _photodiodeConstants.default.capacitorTolerance.five);
    cfext = results[0];
    cf = cfext + cfint; //update cf using new cfext
  }

  //recompute bw and Q with new capacitor value
  bw = Solver.solveBW(cIn, rIn, cf, rf, gbw);

  //Solve for Q
  Q = Solver.solveQ(cIn, rIn, cf, rf, opAmpObject.gbw, bw); //this is not terribly accurate, since it doesn't include op amp secondary pole effect on Q, but it's quick
  var stage1Info = {
    opAmp: opAmpObject,
    bw: bw,
    q: Q,
    rf: rf,
    cf: cf,
    cfint: cfint,
    cfext: cfext,
    cin: cIn,
    rin: rIn,
    rinDisplay: userInputs.shuntResistance,
    status: false,
    statusMessage: "",
    needFaster: false
  };

  //determine op amp status based on bw and cf
  results = (0, _circuit.opAmpStatus_TIA)(stage1Info, userInputs);
  stage1Info.status = results.status;
  stage1Info.statusMessage = results.statusMessage;
  stage1Info.needFaster = results.needFaster;

  //return information to caller
  return stage1Info;
}
function calculateTwoStages_FindOpAmp(userInputs, opAmpDB) {
  var stage1 = null,
    stage2 = null,
    stage1Array = [],
    results,
    needSomeSpeed = 0;

  /*Get stage1 info for all op amps*/
  for (let i = 0; i < opAmpDB.length; i++) {
    stage1 = stage1Info_DualStage(userInputs, opAmpDB[i]);
    stage1Array.push(stage1);
    needSomeSpeed += stage1.needFaster;
  }

  /*Pick the highest scoring op amp out of the recommended list for stage 1*/
  results = (0, _circuit.pickOpAmp_TIA)(stage1Array, userInputs, opAmpDB, needSomeSpeed);
  if (results instanceof _modelError.default) {
    return results;
  }
  stage1 = results.stage1;

  //if no errors, get 2nd stage
  results = calculate2ndStage(userInputs, opAmpDB, stage1.opAmp);
  if (results instanceof _modelError.default) return results;
  stage2 = results.stage2;
  return {
    stage1: stage1,
    stage2: stage2
  };
}
function findOpAmp1(userInputs, opAmpDB) {
  var stage1 = null,
    stage1Array = [],
    results,
    needSomeSpeed = 0;

  /*Get stage1 info for all op amps*/
  for (let i = 0; i < opAmpDB.length; i++) {
    stage1 = stage1Info_DualStage(userInputs, opAmpDB[i]);
    stage1Array.push(stage1);
    needSomeSpeed += stage1.needFaster;
  }

  /*Pick the highest scoring op amp out of the recommended list for stage 1*/
  results = (0, _circuit.pickOpAmp_TIA)(stage1Array, userInputs, opAmpDB, needSomeSpeed);
  if (results instanceof _modelError.default) return results;
  stage1 = results.stage1;
  return stage1.opAmp;
}
function findOpAmp2(userInputs, opAmpDb, stage1OpAmpPartNumber) {
  var stage2;
  var stage2Array = [];
  let stage1OpAmpObject = opAmpDb.find(p => p.partNumber == stage1OpAmpPartNumber);
  for (let i = 0; i < opAmpDb.length; i++) {
    stage2 = stage2Info(userInputs, opAmpDb[i], stage1OpAmpObject);
    stage2Array.push(stage2);
  }
  var results = pickOpAmp_2ndStage(stage2Array, opAmpDb, stage1OpAmpObject);
  if (results instanceof _modelError.default) return results;
  stage2 = results.stage2;
  return stage2.opAmp;
}

//This function calculates the two stages if the first op amp is fixed
function calculateTwoStages_FixedOpAmp(userInputs, opAmpDB) {
  var results, i, opAmpObject;
  var stage1 = null,
    stage2 = null;
  var errorObject = {
    errorCode: "",
    errorParameter: {},
    notRecommendedAvailable: false
  };

  /*Find op amp object*/
  var opAmpName = userInputs.opAmps[0];
  for (i = 0; i < opAmpDB.length; i++) {
    if (opAmpDB[i].partNumber === opAmpName) {
      opAmpObject = opAmpDB[i];
      break;
    }
  }

  /*Get stage1 info for our op amp*/
  stage1 = stage1Info_DualStage(userInputs, opAmpObject);

  //show error message if no good op amp
  if (stage1.status != _photodiodeConstants.default.opAmpStatus.allowed && stage1.status != _photodiodeConstants.default.opAmpStatus.recommended) {
    errorObject.errorCode = _errorCodes.default.fixedOpAmpNoGood;
    errorObject.errorParameter.partName = opAmpName;
    errorObject.errorParameter.statusMessage = stage1.statusMessage;
    return (0, _model.setModelError)(errorObject);
  }

  //get 2nd stage
  results = calculate2ndStage(userInputs, opAmpDB, stage1.opAmp);
  if (results instanceof _modelError.default) return results;
  stage2 = results.stage2;
  return {
    stage1: stage1,
    stage2: stage2
  };
}
function stage1Info_DualStage(userInputs, opAmpObject) {
  let bw = userInputs.speed;
  let cDiff = opAmpObject.cDiff;
  let cCm = opAmpObject.cCm;
  let cIn = cDiff + cCm + userInputs.capacitance;
  let Q = userInputs.peaking;
  let gbw = computeGbw(opAmpObject);
  let rIn = computeRin(userInputs, opAmpObject);
  if (gbw <= bw) {
    let status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    let statusMessage = [];
    statusMessage.push({
      key: _messages.default.amp_status_gbw_less_than_bandwith_requested
    });
    let needFaster = 2;
    let stage1Info = {
      status: status,
      statusMessage: statusMessage,
      opAmp: opAmpObject,
      bw: bw,
      q: Q,
      rf: NaN,
      cf: NaN,
      cin: cIn,
      rin: rIn,
      needFaster: needFaster
    };
    return stage1Info;
  }
  let totalGain = computeTotalGain(userInputs);
  let rfValues = computeRf(gbw, bw, cIn, rIn, Q, totalGain);
  let rf = rfValues.standardRf;
  let cf = computeCf(gbw, bw, cIn, rIn, Q, rfValues, totalGain);
  var cfint = opAmpObject.cfint;
  var cfext = cf - cfint;

  //recompute bw and Q with new rf and cf values
  let newBw = Solver.solveBW(cIn, rIn, cf, rf, gbw);
  let newQ = Solver.solveQ(cIn, rIn, cf, rf, opAmpObject.gbw, newBw); //not terribly accurate, since doesn't include effect of secondary op amp pole, but fast

  let stage1Info = {
    opAmp: opAmpObject,
    bw: newBw,
    q: newQ,
    rf: rf,
    cf: cf,
    cfint: cfint,
    cfext: cfext,
    cin: cIn,
    rin: rIn,
    rinDisplay: userInputs.shuntResistance,
    status: false,
    statusMessage: "",
    needFaster: false
  };
  let results = (0, _circuit.opAmpStatus_TIA)(stage1Info, userInputs);
  stage1Info.status = results.status;
  stage1Info.statusMessage = results.statusMessage;
  stage1Info.needFaster = results.needFaster;
  return stage1Info;
}
function stage2Info(userInputs, opAmpObject, stage1OpAmpObject) {
  let totalGain = computeTotalGain(userInputs);
  let stage1Values = getStage1Values(userInputs, stage1OpAmpObject, totalGain);
  let stage2Gain = totalGain / stage1Values.rf;
  let rgPlusRf = Common.determineStartingR3R4Value(_photodiodeConstants.default.optimizationType.voltageRange, stage1Values.bw);

  //if photodiode is biased negative, output of first stage is positive, so we need a non-inverting configuration
  //else we have an inverting configuration.   Calculate noiseGain so we can use the same code for both.
  let noiseGain;
  if (userInputs.biasPreference === _photodiodeConstants.default.biasPreferenceOptions.negative) {
    noiseGain = stage2Gain;
  } else {
    noiseGain = stage2Gain + 1;
  }
  let rg;
  let rf;
  let results;
  if (noiseGain > 2) {
    //rf is bigger, so do it first
    rf = rgPlusRf - rgPlusRf / noiseGain;
    results = Common.resistorBasedOnTolerance(rf, _photodiodeConstants.default.resistorTolerance.fiveTenths);
    rf = results[0];
    rg = rf / (noiseGain - 1);
    results = Common.resistorBasedOnTolerance(rg, _photodiodeConstants.default.resistorTolerance.fiveTenths);
    rg = results[0];
  } else if (noiseGain > 1.005) {
    //rg is bigger so do it first
    rg = rgPlusRf / noiseGain;
    results = Common.resistorBasedOnTolerance(rg, _photodiodeConstants.default.resistorTolerance.fiveTenths);
    rg = results[0];
    rf = rg * (noiseGain - 1);
    results = Common.resistorBasedOnTolerance(rf, _photodiodeConstants.default.resistorTolerance.fiveTenths);
    rf = results[0];
  } else {
    rg = _photodiodeConstants.default.Limits.INFINITY;
    rf = 0;
  }
  let stage1GBW = null;
  let cfilter;
  let rfilter;
  if (userInputs.biasPreference === _photodiodeConstants.default.biasPreferenceOptions.negative) {
    if (stage1OpAmpObject.feedbackMethod === "Current" && stage1OpAmpObject.cfb) {
      stage1GBW = stage1OpAmpObject.cfb.zbw / stage1OpAmpObject.cfb.rIn;
    } else {
      stage1GBW = stage1OpAmpObject.gbw;
    }
    var calculateRFIlterResults = calculateRFilter(stage1GBW, userInputs.speed);
    //  results = calculateRFilter(stage1GBW, stage1.bw);
    cfilter = calculateRFIlterResults.cfilter;
    rfilter = calculateRFIlterResults.rfilter;
  } else {
    cfilter = 1 / (2 * Math.PI * rf * userInputs.speed);
    //cfilter = 1 / (2 * Math.PI * rf * stage1.bw);
    var capacitorBasedOnToleranceResults = Common.capacitorBasedOnTolerance(cfilter, _photodiodeConstants.default.capacitorTolerance.five);
    cfilter = capacitorBasedOnToleranceResults[0];
    rfilter = undefined;
  }
  var opAmpStatus2ndStageResults = opAmpStatus_2ndStage(rf, rg, userInputs, opAmpObject);
  return {
    status: opAmpStatus2ndStageResults.status,
    statusMessage: opAmpStatus2ndStageResults.statusMessage,
    opAmp: opAmpObject,
    bw: stage1Values.bw,
    rg: rg,
    rf: rf,
    cfilter: cfilter,
    rfilter: rfilter
  };
}

//Computes the feedback resistors, rf, for the transimpedance stage.
function oneStageRf(userInputs) {
  var rf, results;
  var errorObject = {
    errorCode: "",
    errorParameter: {},
    notRecommendedAvailable: false
  };

  //To avoid division by zero, this equation assumes peak current is nonzero.  Since we check for this when user inputs, should be safe assumption.
  rf = userInputs.peakVoltage / userInputs.peakCurrent;
  if (rf > _photodiodeConstants.default.Limits.RBIG_COMP_LIMIT) {
    errorObject.errorCode = _errorCodes.default.OneStage.oneStageRf.rfTooHigh;
    return (0, _model.setModelError)(errorObject);
  }
  results = Common.resistorBasedOnTolerance(rf, _photodiodeConstants.default.resistorTolerance.fiveTenths);
  return {
    rf: results[0]
  };
}
function pickOpAmp_2ndStage(stage2Array, opAmpDB, stage1OpAmpObject) {
  var stage2;
  var errorObject = {
    errorCode: "",
    errorParameter: {},
    notRecommendedAvailable: false
  };
  var lowestSupplyCurrent = 1e60;
  for (var i = 0; i < stage2Array.length; i++) {
    if (stage2Array[i].status === _photodiodeConstants.default.opAmpStatus.recommended) {
      //if the op amp used in the first stage is recommended for the second stage, just use that one 
      if (stage2Array[i].opAmp.partNumber === stage1OpAmpObject.partNumber) {
        stage2 = stage2Array[i];
        lowestSupplyCurrent = opAmpDB[i].supplyCurrent;
        break;
      }
      //otherwise pick the op amp with the lowest supply current that is still recommended
      if (opAmpDB[i].supplyCurrent < lowestSupplyCurrent) {
        lowestSupplyCurrent = opAmpDB[i].supplyCurrent;
        stage2 = stage2Array[i];
      }
    }
  }

  //No op amps were recommended
  if (lowestSupplyCurrent === 1e60) {
    errorObject.errorCode = _errorCodes.default.TwoStage.pickOpAmp_2ndStage.noOpAmpAvailable;
    return (0, _model.setModelError)(errorObject);
  }
  return {
    stage2: stage2
  };
}

//This function determines whether the TIA op amp is recommended, allowed, or not allowed
function opAmpStatus_2ndStage(rf, rg, userInputs, opAmpObject) {
  var notAllowedString = [];
  var allowedString = [];
  var status = _photodiodeConstants.default.opAmpStatus.recommended;
  var statusMessage = [];
  var slewrate = opAmpObject.slewRate;
  var gbw = null;
  if (opAmpObject.feedbackMethod === "Current" && opAmpObject.cfb) {
    //if current feedback, we can use all the same voltage feedback equations if we just make these two changes:
    rg = opAmpObject.cfb.rIn * rg / (opAmpObject.cfb.rIn + rg);
    gbw = opAmpObject.cfb.zbw / rg;
  } else {
    gbw = opAmpObject.gbw;
  }

  //Check if we are below min slew rate.   If so, first set to "allowed".  If really bad, we'll set to "not allowed" later
  var minSlewRate = Math.PI * 2 * userInputs.speed * userInputs.peakVoltage / 2 * userInputs.peaking;
  if (opAmpObject.slewRate * 1e6 < minSlewRate && status === _photodiodeConstants.default.opAmpStatus.recommended) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_slew_rate_marginal
    }); //"slew rate marginal; ";
  }

  //AD8634 is a super expensive, high temp amp.   We want in the tool in case the high temp guys want it, but don't want
  //to recommend.   (In reality, given its 200 nA bias current, highly unlikely to be used as photodiode amp, but just in case
  if (opAmpObject.partNumber === "AD8634") {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_specialty_amp
    }); //"specialty amplifier; "
  }

  // If status is Not Recommended for New Designs or Last Time Buy, you need to make this allowed
  // instead of recommended
  if (opAmpObject.deviceStatus === 4) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_not_recommended_for_new_designs
    });
  } else if (opAmpObject.deviceStatus === 5) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_last_time_buy
    });
  }

  //Check output swing
  var maxOpAmpOutput = opAmpObject.maxSupplyVoltage / 2 - opAmpObject.outHeadroomPlus;
  if (userInputs.peakVoltage > maxOpAmpOutput) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_voltage_not_enough
    }); //"voltage range not enough for peak output voltage; ";
  }

  //Check if gain bandwidth is high enough
  var noiseGain = 1 + rf / rg;
  var gbwNeeded = noiseGain * userInputs.speed;
  if (gbw < gbwNeeded) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_not_fast_enough
    }); // "not fast enough; ";
  }

  //only check for slew rate if we haven't failed already (if op amp not fast enough, telling user slew rate is also no good is redundant)
  minSlewRate = minSlewRate * 0.8; //  Allow for slightly slower slew rates.  This makes marginal slew rate op amps "not recommended".
  if (slewrate * 1e6 < minSlewRate && status !== _photodiodeConstants.default.opAmpStatus.notAllowed) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_slew_rate_low
    }); //"slew rate too low; ";
  }
  if (opAmpObject.feedbackMethod === "Current") {
    if (userInputs.biasPreference === _photodiodeConstants.default.biasPreferenceOptions.positive) {
      //inverting configuration uses a capacitor in the feedback path: a no-no for current feedback parts
      status = _photodiodeConstants.default.opAmpStatus.notAllowed;
      notAllowedString.push({
        key: _messages.default.amp_status_cfb_no_cf
      });
    }
    if (rf < opAmpObject.cfb.minRf) {
      status = _photodiodeConstants.default.opAmpStatus.notAllowed;
      notAllowedString.push({
        key: _messages.default.amp_status_cfb_rf_too_small
      });
    }
  }

  //In inverting configuration, only allow gain=1 stable op amps, since we have cap in feedback path.
  //In non-inverting configuration, we only allow op amps with min stable gain less than noise gain.
  var minStableGain = opAmpObject.minStableGain;
  if (userInputs.biasPreference === _photodiodeConstants.default.biasPreferenceOptions.positive && minStableGain > 1 || minStableGain > noiseGain) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_min_stable_gain,
      data: opAmpObject.minStableGain
    }); //"Min stable gain = __;"
  }

  // If status is Obsolete, the op amp becomes not allowed
  if (opAmpObject.deviceStatus === 6) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_obsolete
    });
  }
  if (status === _photodiodeConstants.default.opAmpStatus.notAllowed) statusMessage = notAllowedString; //remove last semicolon and space
  else if (status === _photodiodeConstants.default.opAmpStatus.allowed) statusMessage = allowedString; //remove last semicolon and space

  return {
    status: status,
    statusMessage: statusMessage
  };
}
function calculate2ndStage(userInputs, opAmpDB, stage1OpAmpObject) {
  var opAmpObject, i, stage2;
  var stage2Array = [];
  var errorObject = {
    errorCode: "",
    errorParameter: {},
    notRecommendedAvailable: false
  };

  //If 2nd stage is locked
  if (userInputs.opAmps[1]) {
    /*Find op amp object*/
    var opAmpName = userInputs.opAmps[1];
    for (i = 0; i < opAmpDB.length; i++) {
      if (opAmpDB[i].partNumber === opAmpName) {
        opAmpObject = opAmpDB[i];
        break;
      }
    }
    stage2 = stage2Info(userInputs, opAmpObject, stage1OpAmpObject);
    if (stage2.status != _photodiodeConstants.default.opAmpStatus.allowed && stage2.status != _photodiodeConstants.default.opAmpStatus.recommended) {
      errorObject.errorCode = _errorCodes.default.fixedOpAmpNoGood;
      errorObject.errorParameter.partName = opAmpName;
      errorObject.errorParameter.statusMessage = stage2.statusMessage;
      return (0, _model.setModelError)(errorObject);
    }
  }

  //if 2nd stage is unlocked, find a good op amp
  else {
    //Get stage2 info for all op amps*/
    for (i = 0; i < opAmpDB.length; i++) {
      stage2 = stage2Info(userInputs, opAmpDB[i], stage1OpAmpObject);
      stage2Array.push(stage2);
    }

    //Pick the highest scoring op amp out of recommended list for stage 2
    var results = pickOpAmp_2ndStage(stage2Array, opAmpDB, stage1OpAmpObject);
    if (results instanceof _modelError.default) return results;
    stage2 = results.stage2;
  }
  return {
    stage2: stage2
  };
}
function getStage1Values(userInputs, stage1OpAmpObject, totalGain) {
  let bw = userInputs.speed;
  let cDiff = stage1OpAmpObject.cDiff;
  let cCm = stage1OpAmpObject.cCm;
  let cIn = cDiff + cCm + userInputs.capacitance;
  let Q = userInputs.peaking;
  let gbw = computeGbw(stage1OpAmpObject);
  let rIn = computeRin(userInputs, stage1OpAmpObject);
  let rf;
  if (gbw <= bw) {
    rf = NaN;
  }
  let rfValues = computeRf(gbw, bw, cIn, rIn, Q, totalGain);
  rf = rfValues.standardRf;
  let theoreticalRf = rfValues.theoreticalRf;
  let cf = computeCf(gbw, bw, cIn, rIn, Q, theoreticalRf, totalGain);
  let newBw = Solver.solveBW(cIn, rIn, cf, rf, gbw);
  let newQ = Solver.solveQ(cIn, rIn, cf, rf, stage1OpAmpObject.gbw, newBw);
  return {
    rf: rf,
    cf: cf,
    bw: newBw,
    Q: newQ
  };
}
function calculateRFilter(opampGBW, bw) {
  var rfilter, cfilter;
  //get rfilter first; pick resistor based on opampGBW so we pick bigger resistors for slow parts and smaller resistors for faster ones
  rfilter = Common.determineStartingR3R4Value(_photodiodeConstants.default.optimizationType.noise, opampGBW / 50);
  //then calculate capacitor value 
  cfilter = 1 / (2 * Math.PI * rfilter * bw);
  var results = Common.capacitorBasedOnTolerance(cfilter, _photodiodeConstants.default.capacitorTolerance.twenty);
  cfilter = results[0];
  // then go back and refine resistor choice based on that
  rfilter = 1 / (2 * Math.PI * cfilter * bw);
  results = Common.resistorBasedOnTolerance(rfilter, _photodiodeConstants.default.resistorTolerance.fiveTenths);
  rfilter = results[0];
  return {
    rfilter: rfilter,
    cfilter: cfilter
  };
}
function computeRin(userInputs, opAmpObject) {
  var rIn = userInputs.shuntResistance;
  if (opAmpObject.feedbackMethod === "Current" && opAmpObject.cfb) {
    //if current feedback, we can use all the same voltage feedback equations if we just make this change to rIn:
    rIn = opAmpObject.cfb.rIn;
  }
  return rIn;
}
function computeGbw(opAmpObject) {
  let gbw = opAmpObject.gbw;
  if (opAmpObject.feedbackMethod === "Current" && opAmpObject.cfb) {
    //if current feedback, we can use all the same voltage feedback equations if we just make this change to gbw:
    var rIn = opAmpObject.cfb.rIn;
    gbw = opAmpObject.cfb.zbw / rIn;
  }
  return gbw;
}
function computeRf(gbw, bw, cIn, rIn, Q, totalGain) {
  let theoreticalRf = Solver.solveRf_CfFlexible(gbw, bw, cIn, rIn, Q);
  let adjustedRf = theoreticalRf;
  if (theoreticalRf > totalGain || theoreticalRf > _photodiodeConstants.default.Limits.RBIG_COMP_LIMIT) {
    adjustedRf = Math.min(totalGain, _photodiodeConstants.default.Limits.RBIG_COMP_LIMIT);
  }
  let results = Common.resistorBasedOnTolerance(adjustedRf, _photodiodeConstants.default.resistorTolerance.fiveTenths);
  return {
    standardRf: results[0],
    theoreticalRf: theoreticalRf,
    adjustedRf: adjustedRf
  };
}
function computeCf(gbw, bw, cIn, rIn, Q, rf, totalGain) {
  var cf = Solver.solveCf_RfFlexible(gbw, bw, cIn, rIn, Q);
  let theoreticalRf = rf.theoreticalRf;
  if (theoreticalRf > totalGain || theoreticalRf > _photodiodeConstants.default.Limits.RBIG_COMP_LIMIT) {
    cf = Solver.solveCf_BWFlexible(rf.adjustedRf, rIn, Q, cIn, gbw);
  }

  //convert cf to standard value if larger than 1 pf.   If smaller, we assume board parasitic capacitance will have 
  //a larger effect than the tolerance. 
  if (cf > _photodiodeConstants.default.Limits.CSMALL_COMP_1PF) {
    let results = Common.capacitorBasedOnTolerance(cf, _photodiodeConstants.default.capacitorTolerance.five);
    cf = results[0];
  }
  return cf;
}
function computeTotalGain(userInputs) {
  var totalGain = userInputs.peakVoltage / userInputs.peakCurrent;
  return totalGain;
}